<template>
  <div
    v-if="store.loaded && !store.showMobile"
    :class="[
      'main-wrapper', 
      {'about-active' : $route.name ===  'about'},
      {'viewer-active' : $route.name ===  'project'},
      {'transition-active' : isTransition}
    ]"
  >
    <div class="about">
      <about-view/>
    </div>
    <div class="main">
      <div class="logo-block">
        <logo-block/>
      </div>
      <div class="menu-block">
        <menu-block/>
      </div>
    </div>
    <div class="media" ref="media">
      <media-block :category="curCategory" :delta-y="deltaY"/>
    </div>
    <div class="viewer">
      <viewer-block/>
    </div>
  </div>
  <!-- ================ -->
  <!-- Мобильная версия -->
  <!-- ================ -->
  <div v-if="store.loaded && store.showMobile" class="mobile-wrapper">
    <div class="mobile-media">
      <media-block :category="curCategory" :deltaY="deltaY"/>
    </div>
    <div v-if="$route.name ===  'about'" class="mobile-home-about">
      <about-view/>
    </div>
    <div class="mobile-header">
      <logo-block/>
      <menu-block/>
    </div>
    <div :class="['viewer', 'mobile-viewer', {'mobile-viewer-active': $route.name ===  'project'}]">
      <viewer-block/>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { useRoute } from 'vue-router'
  import { useMainStore } from '../store'
  import LogoBlock from '../components/LogoBlock.vue'
  import MenuBlock from '../components/MenuBlock.vue'
  import MediaBlock from '../components/MediaBlock.vue'
  import ViewerBlock from '../components/ViewerBlock.vue'
  import AboutView from '../views/AboutView.vue'

  export default defineComponent({
    name: 'HomeView',
    components: {
      LogoBlock, MenuBlock, AboutView, MediaBlock, ViewerBlock
    },
    props: {
      category: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        route: useRoute,
        store: useMainStore(),
        curCategory: '',
        isTransition: false,
        deltaY: 0
      }
    },
    watch: {
      $route (to, from) {
        // Проверяем, что категория требуется для обновления массива в Media
        // т.е. не About или Project
        if (!['about', 'project'].includes(String(this.$route.name))) {
          this.curCategory = String(this.$route.params.category)
        }
        if (to !== from) {
          this.isTransition = true
          setTimeout(() => {this.isTransition = false}, 1100)
        }
      }        
    },
    methods: {
      onResize () {
        this.store.showMobile = window.innerWidth < this.store.maxWidth
      },
      onWheel (e: WheelEvent) {
        if (!['about', 'project'].includes(String(this.$route.name))) {
          this.deltaY = e.deltaY * 2 //  2 – Двойная скорость прокрутки
        }
      }
    },
    async mounted() {
      this.store.loadMedia()
      this.onResize()
      window.addEventListener('resize', this.onResize)
      window.addEventListener('wheel', this.onWheel)
    },
    beforeUnmount () {
      window.removeEventListener('resize', this.onResize)
      window.removeEventListener('wheel', this.onWheel)
    }
  })
</script>

<style scoped>

.main-wrapper {
  position: fixed;
  left: -50vw;
  height: 100%;
  width: 150vw;
  display: grid;
  grid-template-columns: repeat(3, 1fr) 2fr;
}

.transition-active {
  transition: all 1s ease-in-out;
}

.about-active {
  left: 0;
  /* transition: all 1s ease-in-out; */
}

.viewer-active {
  left: -150vw;
  /* transition: all 1s ease-in-out; */
}

.about, .main, .media {
  width: 50vw;
  position: relative;
}

.viewer {
  overflow-y: auto;
  width: 100vw;
  position: relative;
  background-color: var(--background_color);
}

.about {
  display: grid;
  max-height: 100vh;
  padding-bottom: 5rem;
}

.logo-block, .menu-block {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  /* width: 40rem; */
  /* transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1); */
}

.menu-block {
  padding-top: 5rem;
}

/* ================ */
/* Мобильная версия */
/* ================ */
.mobile-wrapper {
  /* height: 100svh; */
}

.mobile-header {
  position: fixed;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  height: 6rem;
  background-color: #eeeeeeff;
  box-shadow: 0 0 50px #8f8f8f59;
}

.mobile-media {
  width: 100vw;
}

.mobile-viewer {
  position: fixed;
  height: 100dvh;
  transform: translateY(-100%);
  transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);
}

.mobile-viewer-active {
  transform: translateY(0);
  transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);
}

.mobile-home-about {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: var(--background_color);
  overflow-y: auto;
}
</style>